import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';

import CustomerDashboard from './dashboard/CustomerDashboard';

class Dashboard extends Component {
    renderUserDashboardList() {
        return <CustomerDashboard />;
    }

    render() {
        return (
            <Container fluid="lg">
                {this.props.user && this.renderUserDashboardList()}
            </Container>
        );
    }
}

// <Test />

function mapStateToProps(store) {
    return {
        user: store.users.user,
    };
}

Dashboard.propTypes = {
    user: PropTypes.object,
};

export default connect(mapStateToProps)(Dashboard);
